import { render, staticRenderFns } from "./document-dialog.vue?vue&type=template&id=57986134&scoped=true"
import script from "./document-dialog.vue?vue&type=script&lang=js"
export * from "./document-dialog.vue?vue&type=script&lang=js"
import style0 from "./document-dialog.vue?vue&type=style&index=0&id=57986134&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57986134",
  null
  
)

export default component.exports